import { Datas3d } from './datas3d';
import { Poste3d } from './poste3d';
import { Puerta3d } from './puerta3d';
import { Varios3d } from './varios3d';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { SubSection } from './sub-section';
import { Panels3d } from './panels3d';
import * as THREE from 'three';
import { Utils } from '../../utils.module';
import { UtilsBuilder } from '../utils-builder';
import { data } from 'jquery';
import { ProjectDataPerimetro } from 'src/app/entities/project-data-perimetro.entity';
import { Console } from 'console';

export class GestorDatas3d {

	// El editor scheme2 un metro es 0.01 y en THREE un metro lo interpretamos como 1, así, el ajuste es (valor * 100.0).
	private static SCALE100 = 100.0;
	//private static SCALE1000 = 1000.0;

	// Si es true, se hace la petición de carga de archivos 3D (POR DEFECTO).
	// Si es false, no se hace la petición de carga de archivos 3D solo se obtiene la infromación, usado por el presupuesto.
	private WITH_3D = true;

	// ##########################################################################################

	private _proyecto: ProjectData;

	public postes: Poste3d;
	public puertas: Puerta3d;
	public varios: Varios3d;
	public bastidores: Panels3d;
	public datas: Datas3d[];
	public ColorNeutro: THREE.MeshPhongMaterial;

	public calculoPosteCuadrado :any[];
	public posicionPosteDoble:any;
	public vectorDirectorAB: any;
	public objetoPosteDoble: { posteBase: { posteBaseX: any; posteBaseY: any; }; postePuntoAx: number; postePuntoAy: number; postePuntoBx: any; postePuntoBy: any; };

	private _procesando = 0; // No está procesando.
	public get processando() { return this._procesando; }
	//private _procesandoLimite = 0; // Tiempo limite para procesar.
	private _cantidadPeticiones = 0; // Cantidad de peticiones en espera.
	public get ProccessEnd(): boolean {
		return (this._cantidadPeticiones === 0 && this._procesando === 0);
	}
	private _status = 0; // Como finaliza el proceso => 0 = OK, 1 = límite de tiempo superado.
	public get status() { return this._status; }


	constructor(debug = false) {
		this.postes = new Poste3d('assets/3D/', debug);
		this.puertas = new Puerta3d('assets/3D/', debug);
		this.varios = new Varios3d('assets/3D/', debug);
		this.bastidores = new Panels3d('assets/3D/', debug);

		// Material usado para colorear.
		this.ColorNeutro = new THREE.MeshPhongMaterial({ color: 0xffffff, specular: 0, emissive: 0, shininess: 0 });
	}

	public releaseResources()
	{
		if( this.postes ) {
			this.postes = null;
		}

		if( this.puertas ) {
			this.puertas = null;
		}

		if( this.varios ) {
			this.varios = null;
		}

		if( this.bastidores ) {
			this.bastidores = null;
		}

		if( this.ColorNeutro ) {
			this.ColorNeutro.dispose();
			this.ColorNeutro = null;
		}
		
		if( this.datas ) {
			this.datas = null;
		}
	}

	public insertNo3D(proyecto: ProjectData, obj3d = false) {
		this.WITH_3D = obj3d;
		// Linkar proyecto.
		this._proyecto = proyecto;
		this.datas = [];

		if (proyecto.renderer === Utils.SATELITE) {
			//if (this._procesando === 0) this.elevationsSatelite();
		}
		else {
			// Sacar datos sin procesar y lanzar los cargadores necesarios.
			for (let perimetro of proyecto.perimetro) {
				let datas3d = new Datas3d();
				datas3d.setDatas(perimetro, this.bastidores, this.postes, this.varios, this.WITH_3D);
				// console.log('Magnitud process 1')
				this._proccessCoordinates(datas3d);
				this.datas.push(datas3d);
			}
		}
	}

	public insert(proyecto: ProjectData) {
		// Linkar proyecto.
		this._proyecto = proyecto;
		this.datas = [];

		// Sacar datos sin procesar y lanzar los cargadores necesarios.
		for (let perimetro of proyecto.perimetro) {
			let datas3d = new Datas3d();
			datas3d.setDatas(perimetro, this.bastidores, this.postes, this.varios, this.WITH_3D);
			this._proccessCoordinates(datas3d);
			this.datas.push(datas3d);
		}
	}

	//##################################################################################################################
	// Calcula el angulo entre dos líneas que se intersectan.
	// Obtiene la dirección del angulo.
	private _computeAngles(data: Datas3d) {
		// Computar angulos.
		let angulos = [];
		// ############################################# CERRADO.
		//	let anterior = 0;
		for (let i = 0; i < data.coors.length - 1; i++) {
			// Inicio por defecto si está abierto y es el primero.
			let puntoAx = 0;
			let puntoAy = 0;

			// Si es el primero se comporta distinto si está cerrado el perímtero.
			if (i == 0) {
				// Si está cerrado, el primer y último poste son el mismo.
				if (data.closed) { // Coger el penultimo.
					puntoAx = data.coors[data.coors.length - 2].x; // Punto Ax
					puntoAy = data.coors[data.coors.length - 2].y; // Punto Ay
				}
				else { // Es una punta.
					puntoAx = data.coors[i].x;
					puntoAx += (puntoAx < 0) ? -10 : 10;
					puntoAy = data.coors[i].y;
				}
			}
			else { // Postes intermedios sin contar el último.
				puntoAx = data.coors[i - 1].x; // Punto Ax
				puntoAy = data.coors[i - 1].y; // Punto Ay
			}

			// Obtener los calculos.
			let result = this._angles(
				data.coors[i].x, data.coors[i].y,			// Base
				puntoAx, puntoAy, 							// Punto A
				data.coors[i + 1].x, data.coors[i + 1].y 	// Punto B
			);

			/**Creamos el objeto PosteDoble donde vamos a almacenar toda la información para calcular donde tendrían que ir los postes dobles*/
			// this.objetoPosteDoble = {
			// posteBase : { posteBaseX :data.coors[i].x, 
			// 	posteBaseY :data.coors[i].y},
			// 	postePuntoAx : puntoAx,
			// 	postePuntoAy : puntoAy,
			// 	postePuntoBx : data.coors[i+1].x,
			// 	postePuntoBy : data.coors[i+1].y
			// }
		
			//Creamos las variables de los grados que necesitamos para poner postes dobles:
			/** entre 90 : 87 y 93
			*  entre 180 : 177 y 183
			*  entre 270: 267 y 273
			*/
			let margenErrorGrados = 3;
			let resta90 = 90 - margenErrorGrados;
			let suma90 = 90 + margenErrorGrados;
			let resta180 = 180 - margenErrorGrados;
			let suma180 = 180 + margenErrorGrados;
			let resta270 = 270 - margenErrorGrados;
			let suma270 = 270 + margenErrorGrados;

			let cuadrado = -1;
			if(data.perimetro.producto.tipoPoste){
				cuadrado = data.perimetro.producto.tipoPoste.indexOf("Cuadrado");
			}
			/**CONDICIONES
			Solo se asignará un valor si:
			Se utiliza un bastidor con poste cuadrado
			El ángulo calculado entre dos tramos es diferente de:
			90º ± margenError
			180º ± margenError
			270º ± margenError */
			let longitudCoors = data.coors.length-1;
			let cerrado = (data.coors[0].x == data.coors[longitudCoors].x);
			let bcond1 = cuadrado != -1;
			let bcond2 = (result.grados < resta90 || result.grados > suma90);
			let bcond3 = (result.grados < resta180 || result.grados > suma180);			
			let bcond4 = (result.grados < resta270 || result.grados > suma270);
			let bcond5 = (i != 0 && !cerrado);
			let bcond6 = (i < data.coors.length-1);	
			let muro = (data.perimetro.informacion.elevaciones);
		
			
			let pA = {x: puntoAx, y: puntoAy}
			let pB = {x: data.coors[i].x, y: data.coors[i].y}

			/** En caso de que el perímetro no esté cerrrado se geneeran una serie de condiciones para incluir poste adicional o dejarlo en undeefined porque no nos interesa*/

			if(!cerrado){
				if(bcond1 && bcond2 && bcond3 && bcond4 && bcond5 && bcond6 ){
					data.coors[i].posteAdicional = this.generaPosteDoble(pA, pB);
				}else{
						data.coors[i].posteAdicional.x = undefined;
						data.coors[i].posteAdicional.y = undefined;			
					}
					/** En caso de que el perímetro esté cerrado tenemos qu ecomprobar si tiene que generar un poste doble o no.*/
			}else{
				
				if(bcond1 && bcond2 && bcond3 && bcond4 && cerrado){
					data.coors[i].posteAdicional = this.generaPosteDoble(pA, pB);
					// console.log("data coors", data.coors[i], "poste Adicional", data.coors[i].posteAdicional);
					data.coors[longitudCoors].posteAdicional.x = data.coors[0].posteAdicional.x;
					data.coors[longitudCoors].posteAdicional.y = data.coors[0].posteAdicional.y;
				}else{
					data.coors[i].posteAdicional.x = undefined;
					data.coors[i].posteAdicional.y = undefined;
				
				}
			}

			

			//data.coors[i].angleSection = ang.sin;
			// Si es el primero y el perímtero está abierto, el angulo del poste base es el mismo que el del tramo.

			data.coors[i].angleStart = result.radianes;
			data.coors[i].grados = result.grados;
			data.coors[i].dir = result.dir;
			angulos.push(result);

		}
		// Los angulos deben seguir el orden de cierre (1,1)(1,-1)(-1,.1)(-1,1) ciclico sin importar donde empieza.
		let siguiente = 0; // Ciclo lógico, guarda el siguiente angulo lógido. 0 No hay mandato. (1,2,3,4)
		let direccion = 1; // 1 Derecha, -1 izquierda; Por defecto se toma la Derecha, después se reajusta.
		let interm = 0; // Se inicia la dirección del perímetro, sentido del reloj.

		// Obtener la dirección inicial.
		if (angulos.length > 1) {
			let aux = angulos[0].dir - 1;
			if (aux == 0) aux = 4;
			if (angulos[1].dir == aux) {
				interm = 1; // Sentido contrario al reloj.
				direccion = -1; // Cambiar dirección.
			}
		}

		let angulo1 = 0;
		for (let ang = 0; ang < angulos.length; ang++) {
			// Tener en cuenta si se inicio.
			if (siguiente == 0) { 	// Iniciar ciclo.
				siguiente = this._siguienteCiclo(direccion, angulos[ang].dir);
			}
			else { 					// Ciclo de angulos. Comprobar si rompe el ciclo.
				if (angulos[ang].dir == siguiente) { // Sigue ciclo.
					siguiente = this._siguienteCiclo(direccion, siguiente);
				}
				else { // Cambiar dirección.
					direccion *= -1;
					interm = (direccion == -1) ? 1 : 0;
					siguiente = this._siguienteCiclo(direccion, angulos[ang].dir);
				}
			}
			data.coors[ang].interm = interm;
			data.coors[ang].direction = direccion;
			angulo1 += direccion;
		}

		// Dependiendo de la cantidad de angulos gana el que más tiene (ang1, ang2).
		data.direction = -1;
		if (angulo1 < 0) {
			data.direction = 1;
			for (let c of data.coors) c.interm = (c.interm == 0) ? 1 : 0;
		}
	}

	//Método para generar poste doble. Se recoge el poste Base y el poste
	public generaPosteDoble(pA, pB){

		
		// let a = {ax:result.posteBase.posteBaseX, ay:result.posteBase.posteBaseY} //cogemos la posicion del punto BASE
		// let b = {bx:result.postePuntoAx, by:result.postePuntoAy} //cogemos la posicion del punto A
		//Poste cuadrado es 60x60; su fórmula es: d = raiz cuadarada de 60 al cuadrado + 60 al cuadrado = 84.85;
		let distanciaMinima = 0.084852813742385702928101323452582;// distancia de los postes cuadrados 60x06

		//necesitamos cuando el angulo es menor mayor de 90grados para añadir el poste doble
		
		//el vector será el resultado del poste del vector director A
		
		/**Para obtener la posicoin del vector director necesitamos restar la posicion del punto A y punto B de las X y de las Y */
		let vectorAx = pB.x - pA.x; 
		let vectorAy = pB.y - pA.y; 
		//Tenemos una propiedad de la clase y guardamos las propiedades de vector Director para poder usarlas en todo Angular
		this.vectorDirectorAB = {x: vectorAx, y: vectorAy} 

		//Calculamos la normaVectorDirector
		const normaVectorDirector = Math.pow(vectorAx,2) + Math.pow(vectorAy,2);
		let ab :number;
		ab = Math.sqrt(normaVectorDirector); 
		let distancia = ab - distanciaMinima;
		let porcentaje = distancia / ab;
		
		const posicionPosteX = pA.x + (this.vectorDirectorAB.x * porcentaje);
		const posicionPosteY = pA.y + (this.vectorDirectorAB.y * porcentaje);

		this.posicionPosteDoble = {
			x : posicionPosteX,
			y : posicionPosteY
		}

		return this.posicionPosteDoble;
	}

	// Devuelve el siguiente angulo del ciclo.
	private _siguienteCiclo(direccion: number, ciclo: number) {
		ciclo += direccion;
		if (ciclo > 4) return 1;
		if (ciclo < 1) return 4;
		return ciclo;
	}

	//
	private _angles(basex: number, basey: number, x1: number, y1: number, x2: number, y2: number): any {
		x1 -= basex; y1 -= basey; x2 -= basex; y2 -= basey;


		// Obtener la orientación.
		let dir = 0;
		if ((x1 + x2) >= 0) { // (1, ?)
			dir = ((y1 + y2) >= 0) ? 1 : 2; // (1, 1) : (1, -1)
		} else { // (-1, ?)
			dir = ((y1 + y2) >= 0) ? 4 : 3;
		}

		// Producto de las líneas.
		let up = (x1 * x2) + (y1 * y2);
		let down = Math.sqrt((x1 * x1) + (y1 * y1)) * Math.sqrt((x2 * x2) + (y2 * y2));
		let r = up / down;

		let radianes = Math.acos(r);
		return { dir, grados: UtilsBuilder.RadianToAngle(radianes), radianes };
	}

	//##################################################################################################################
	// Procesar los tramos.
	// Genera sub-secciones, por ejemplo una puerta es una sub-sección, un escalón.
	// Las coordenadas reciben 'x,y' del punto incial (A) escalados.
	// Rellena el arreglo 'subSections' con las sub-secciones, como mínimo existe 1.
	// Una vez subdivididas las coordenadas se pasa a situar puertas.
	private _proccessCoordinates(data: Datas3d) {

		// Crear copia de las coordenadas limpias y ajustadas a la escala.
		// Coordenadas (x,y); divisiones del tramo (sections), angulo del tramo (angleSection);
		// angulos del poste inicial (angleStart) y su dirección (direction);
		// usado por las LUX en los angulos según dirección (interm) 0 => Z, 1 => -Z.
		data.coors = [];
		for (let c of data.perimetro.coordenadas) {
			data.coors.push({
				x: c.lng * GestorDatas3d.SCALE100,
				y: c.lat * GestorDatas3d.SCALE100,
				sections: [],
				angleSection: 0,
				angleStart: 0,
				direction: 0,
				interm: -1,
				posteAdicional:{
					x: undefined,
					y: undefined,
				}
			});
		}

		// Calcula el angulo del tramo y los angulos de los postes extremos y sus direcciones.
		this._computeAngles(data);

		// Obtener todos los escalones.
		let stairs = data.perimetro.informacion.elevaciones;
		
		// Almacena la altura del escalón anterior + la altura del muro ().
		let previousElevantion = data.heigthWall;
		let subSection;


		// ###################################################### ESCALONES
		//   Un tramo es una línea que va del punto A al punto B donde A y B son las
		// coordenadas usadas para definir un perímtero en los editores.
		//   Un tramo está dividido en sub-secciones, debe existir una como mínimo.
		//   Una sub-sección es por ejemplo una puerta, una verja o cercado sin muro ...
		//
		//   subSecction {
		//	  x1, y1, // Puntos A de la sub-sección.
		//	  x2, y2, // Puntos B de la sub-sección.
		//    height // Altura en caso de que exista muro o escalones, (es la suma de ambos).
		//    magnitud // Longitud de la sub-sección.
		//    door // Es el ID de mongoDG, describe el tipo de puerta.
		//    marginA, marginB // Margenes que se crean cuando se tienen que mover los postes.
		//   }
		// ######################################################
		// console.log("DATAAAA")
		// console.log(data)
		//lsp = tramo donde se ubica la elevacion
		let subSection2 = null;
		for (let c = 0; c < data.coors.length-1; c++) {
			// Obtener los escalones del tramo.
			let _stairsByCoor = (stairs) ? stairs.filter(stair => { return stair.lsp == c; }) : [];
	

			// Principal, abarca todo el tramo como una sección..

			/*CREAMOS LAS SUBSECTION, para ello creamos el nuevo código para los postes dobles cuando sea cuadrado y tenemos recogidos los datos en el 
			data y dentro data.coors si la sección se han calculado los postesAdicionales, entonces se calcula de la siguiente manera.  */

			/**En caso de no que la sección no tiene posteAdicional, sigue funcionando como siempre */
			 if(data.coors[c+1].posteAdicional.x == undefined){
			 	subSection = new SubSection(data.coors[c].x, data.coors[c].y, data.coors[c+1].x, data.coors[c+1].y, previousElevantion);
			 	data.coors[c].sections.push(subSection);

			/**En caso contrario y la sección tiene posteAdicional, cogemos la subsection y vamos desde el punto inicial al poste adicional de
			 * la siguiente sección y después desde el poste Adicional al siguiente punto
			 */

			 }else{			
				
				subSection = new SubSection(data.coors[c].x, data.coors[c].y, data.coors[c+1].posteAdicional.x, data.coors[c+1].posteAdicional.y, previousElevantion);

				data.coors[c].sections.push(subSection);

				subSection2 = new SubSection(data.coors[c+1].posteAdicional.x, data.coors[c+1].posteAdicional.y, data.coors[c+1].x, data.coors[c+1].y,previousElevantion);

			}



			// Pasar al siguiente en caso de no tener escalones.
			/**En caso de no que la sección no tenga muro, tiene que tener en cuenta si tiene poste adicional para indicarlo  */

			if (_stairsByCoor.length == 0){
				if(data.coors[c+1].posteAdicional.x != undefined){
					data.coors[c].sections.push(subSection2);
				}
				continue;
			}
				

			let stairsByCoor = _stairsByCoor.sort((a, b) => a.startDistance - b.startDistance);

			//-----------------------------------------------------------------------


			data.coors[c].sections[0].setCoordinates2(stairsByCoor[0].fromPointX * GestorDatas3d.SCALE100, stairsByCoor[0].fromPointZ * GestorDatas3d.SCALE100);

			// Último escalón.
			let last = stairsByCoor.length - 1;

			// ######################################################
			for (let indiceStair = 0; indiceStair < stairsByCoor.length; indiceStair++) {
				// Elevación (escalón) viene en metros (0.2 a 6.0).
				previousElevantion = data.heigthWall + stairsByCoor[indiceStair].elevationValue;

				// Tener en cuenta si es el último.
				if (indiceStair == last ) {
					// Como es el último no comprueba el siguiente escalón para las coordenadas.
					// console.log("---Magnitud Subsection 2---")
					/**En caso de que la seccion coincida con la ultima posición, tiene realiza los calculos en la subSection y en caso de tener poste 
					 * adicional el siguiente tramo (seccion), se incluye el subsection2 que le añade la posición del poste Adicional
					 */
					//En caso de pasar por tener escalones se genera una subsection que va desde el punto c.x al siguiente punto de la coor c+1 x

					//En caso de que la siguiente sección, tenga que añadir un poste doble se realiza se busca la posicion de c.x y la suignete posicion es la del poste adicional
					if(data.coors[c + 1].posteAdicional.x != undefined){
						// data.coors[c].sections.push(subSection2);
						let subSection = new SubSection(
							stairsByCoor[indiceStair].fromPointX * GestorDatas3d.SCALE100,
							stairsByCoor[indiceStair].fromPointZ * GestorDatas3d.SCALE100,
							data.coors[c + 1].posteAdicional.x,
							data.coors[c + 1].posteAdicional.y, previousElevantion);
							//se pusea la subsection
						data.coors[c].sections.push(subSection);
						// y se añade la siguiente posición, que sería desde el poste adicional del siguinete punto a la posición del siguiente punto hasta su X,
						// se guarda esa subsection2 creada
						let subSection2 = new SubSection(
							data.coors[c + 1].posteAdicional.x,
							data.coors[c + 1].posteAdicional.y,
							data.coors[c + 1].x,
							data.coors[c + 1].y,previousElevantion
						)
						//se pusea dentro de las section como subsection
						data.coors[c].sections.push(subSection2);

					}else{
						//En caso de no tener poste adicional, actua como anteriormente
						let subSection = new SubSection(
							stairsByCoor[indiceStair].fromPointX * GestorDatas3d.SCALE100,
							stairsByCoor[indiceStair].fromPointZ * GestorDatas3d.SCALE100,
							data.coors[c + 1].x,
							data.coors[c + 1].y, previousElevantion);
						data.coors[c].sections.push(subSection);
					}

				}
				// Tener en cuenta si es el primero.
				else {
					// console.log("---Magnitud Subsection 3---")
					let subSection = new SubSection(
						stairsByCoor[indiceStair].fromPointX * GestorDatas3d.SCALE100,
						stairsByCoor[indiceStair].fromPointZ * GestorDatas3d.SCALE100,
						stairsByCoor[indiceStair + 1].fromPointX * GestorDatas3d.SCALE100,
						stairsByCoor[indiceStair + 1].fromPointZ * GestorDatas3d.SCALE100, previousElevantion);
					data.coors[c].sections.push(subSection);
				}

			}
		}



	

		// ###################################################### PUERTAS
		for (let _door of data.perimetro.puertas) {
			// Ancho total de la puerta.
			const lengthDoor = _door.puerta.longitudTotal/1000; //this.puertas.length(_door.puerta.ID);
			const lengthDoorMiddle = lengthDoor / 2.0;

			if (this.WITH_3D) this.puertas.cargar3D(_door.puerta.ID);

			// Distancia de la puerta, desde el principio hasta el lugar de la puerta.
			let pointDoor = Math.sqrt(Math.pow(data.coors[_door.lsp].x - _door.lng * GestorDatas3d.SCALE100, 2)
				+ Math.pow(data.coors[_door.lsp].y - _door.lat * GestorDatas3d.SCALE100, 2));

			// Adquirir el tramo (un tramo tiene de 1 a n subSections) donde está situada.
			let coor = data.coors[_door.lsp];

			// Puntero a la subSection.
			let subSection: SubSection;
			// Índice a la seccion.
			let indexSubSection = 0;

			// Obtener la subSection donde está la puerta.
			for (indexSubSection = 0; indexSubSection < coor.sections.length; indexSubSection++) {
				subSection = coor.sections[indexSubSection];
				// Si pointDoor está dentro de la subSection.
				if (pointDoor < subSection.magnitud) break;
				// Ajustar para situarse dentro de la sub-section.
				pointDoor -= subSection.magnitud;
			}

			// Si la sección es una puerta no ponerla.
			if (subSection.door !== '') continue;
			// -------------------------------------------------------------

			// En caso de que la puerta sea igual o mayor al largo del tramo -> cambiar tipo tramo.
			//if (pointDoor >= subSection.magnitud) {
			if (_door.longitudPuerta >= subSection.magnitud) {
				subSection.height = 0;
				subSection.door = _door.puerta.ID;
				continue;
			}
			// -------------------------------------------------------------

			// Ajuste del % del margen de la puerta. Se debe tener en cuenta la longitud.
			let unidad = subSection.magnitud / 100;


			//console.log(`let unidad ${unidad} = subSection.magnitud ${subSection.magnitud} / 100;`);

			// Obtener la distancia según el marge de la puerta (%), restando la mitad del ancho de la puerta.
			let r = (unidad * _door.margen) - lengthDoorMiddle;


			// Obtener la distancia transformada.
			let doorMargin = Math.abs(r / unidad);

			// Obtener las coordenadas 3D.
			let xy = this._getXY(subSection.x1, subSection.y1, subSection.x2, subSection.y2, doorMargin);
			//console.log(JSON.stringify(xy));

			// #################################################################################
			// En caso de que la puerta salga por el lado A. (una subSection se dibuja de A -> B)
			// Opciones:
			// Si después de ajustar la puerta es el tamaño de la misma es mayor o igual a la subSection, ésta se convierte en puerta y no hay división.
			// Si la puerta cabe y sobra subSection, se pasa a dividir poniendo primero la puerta y después el resto.
			if (pointDoor - (lengthDoor / 2.0) <= 0) {
				// Obtener las coordenadas final de la puerta según el ancho.
				let doorMargin2 = Math.abs(lengthDoor / unidad);
				let xy2 = this._getXY(subSection.x1, subSection.y1, subSection.x2, subSection.y2, doorMargin2 + 0.07);

				// Almacenar la magnitud general de la subScetion.
				const cache = subSection.magnitud;

				// Crear la subSection que se convierte en valla.
				// Como es una valla se debe enviar la altura 'subSection.height'.
				// console.log("---Magnitud Subsection 4---")
				let subValla = new SubSection(xy2.x, xy2.y, subSection.x2, subSection.y2, subSection.height);

				// La actual subSection cambiarla a puerta.
				subSection.setCoordinates2(xy2.x, xy2.y);
				// console.log("---Magnitud 2---")
				subSection.height = 0;
				subSection.margenError = 0.03; // Desplazamiento.
				subSection.door = _door.puerta.ID;
				// Marcar que sobresale por A.
				subSection.overflowLeft = true;

				// Tener en cuenta si la puerta NO ocupa toda la subSection.
				if (subSection.magnitud < cache) {
					// Insertar después de la puerta la nueva subSection.
					coor.sections.splice(indexSubSection + 1, 0, subValla);
				}
				else {
					// Reajuste final de la subSection, la puerta coge toda la subScetion.
					// console.log("MAGNITUD-reajustefinal: ");
					subSection.setCoordinates(subSection.x1, subSection.y1, subValla.x2, subValla.y2);
					// Marcar que sobresale por B.
					subSection.overflowRight = true;
				}
				continue;
			}
			// #################################################################################
			// En caso de que la puerta salga por el lado B. (una subSection se dibuja de A -> B)
			// Divide la sección en dos, la primera sección queda como valla y la segunda como puerta.
			if (pointDoor + lengthDoorMiddle >= subSection.magnitud) {
				// Restar la puerta a la subSection.
				let magnitudRestante = (subSection.magnitud - 0.03) - lengthDoor;
				
				// Si la puerta es igual o mayor a la magnitud de la subSection, dejar la subSection como puerta.
				if (magnitudRestante <= 0) {
					subSection.door = _door.puerta.ID;
					// Marcar que sobresale.
					subSection.overflowLeft = true;
					subSection.overflowRight = true;
				}
				else {
					// Obtener la posición de la puerta.
					let doorMargin2 = Math.abs(magnitudRestante / unidad);
					let xy2 = this._getXY(subSection.x1, subSection.y1, subSection.x2, subSection.y2, doorMargin2);

					// Crear la subSection que se convierte en puerta. Como es una puerta su altura es 0.
					// console.log("---Magnitud Subsection 5---")
					let newDoor = new SubSection(xy2.x, xy2.y, subSection.x2, subSection.y2);

					newDoor.door = _door.puerta.ID;
					// Marcar que sobresale por B.
					newDoor.overflowRight = true;

					// Inserta delante de la actual subSection la nueva puerta.
					coor.sections.splice(indexSubSection + 1, 0, newDoor);

					// Actualizar la actual subSection.
					subSection.setCoordinates2(xy2.x, xy2.y);
					// console.log("---Magnitud 3---")
				}
				continue;
			}
			// -------------------------------------------------------------

			// En caso de que la puerta tenga margenes.
			// Crear copia e insertar desplazando actual.
			// console.log("---Magnitud Subsection 6---")
			let copy = new SubSection(subSection.x1, subSection.y1, xy.x, xy.y, subSection.height);
			coor.sections.splice(indexSubSection, 0, copy);

			// Calcular XY.
			let r2 = (unidad * _door.margen) + lengthDoorMiddle;
			let doorMargin2 = Math.abs(r2 / unidad);
			let xy2 = this._getXY(subSection.x1, subSection.y1, subSection.x2, subSection.y2, doorMargin2);
			// console.log("---Magnitud Subsection 7---")
			let puerta = new SubSection(xy.x, xy.y, xy2.x, xy2.y);
			puerta.door = _door.puerta.ID;
			// Insertar dejando la puerta en medio.
			coor.sections.splice(indexSubSection + 1, 0, puerta);

			// Actualizar el actual.
			// console.log("MAGNITUD-actualizar: ");
			subSection.setCoordinates(xy2.x, xy2.y, subSection.x2, subSection.y2);
		}
	}

	// Devuelve las coordenadas X e Y de una línea definida por (x1, y1, x2, y2).
	// El punto XY devuelto va desde las coordenadas (x1, y1) + margin.
	private _getXY(x1: number, y1: number, x2: number, y2: number, margin: number): any {
		let pB = { x: x2 - x1, y: y2 - y1 };
		let normalX = 1;
		if (pB.x < 0) { pB.x *= -1; normalX = -1; }
		let normalY = 1;
		if (pB.y < 0) { pB.y *= -1; normalY = -1; }
		// Longitud A-B.
		let hipotenuse = Math.sqrt(Math.pow(pB.x, 2) + Math.pow(pB.y, 2));
		let radio = (hipotenuse * margin) / 100; // %
		// Angulo en radianes.
		let angle = Math.asin(pB.y / hipotenuse);
		return {
			x: ((radio * Math.cos(angle)) * normalX) + x1,
			y: ((radio * Math.sin(angle)) * normalY) + y1
		}
	}

	//
	public get loadFinish() {
		return !(this.postes.cargando || this.puertas.cargando || this.varios.cargando || this.bastidores.cargando);
	}

}
